<template>
  <v-layout row wrap fill-height>
    <v-toolbar app dense color="primary">
      <v-toolbar-title style="color:black;" @click="goToHome">SuburbanServ</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="logout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content style="height: calc(100% - 56px); overflow: auto;">
      <router-view></router-view>
    </v-content>

    <v-bottom-nav :active.sync="activeBtn" :value="true" color="primary" fixed>

      <v-btn flat color="white" value="Meeting" @click="$router.push('/Main/Meeting')">
        <span>Meeting</span>
        <v-icon>mdi-meetup</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      activeBtn: null
    };
  },
  watch: {
    $route(route) {
      this.checkRoute();
    }
  },
  mounted() {
    this.checkRoute();
  },
  methods: {
    checkRoute() {
      let route = this.$route;
      if (route.name == "Meeting") {
        this.activeBtn = "Meeting";
      }
    },
    openRoute(route) {
      this.$router.push(route);
    },
    goToHome() {
      this.activeBtn = null;
      this.$router.push("/Main");
    },
    logout() {
      let storeData = {
        CustomerID: null,
        VenueID: null
      };

      this.$store.commit("setLastCheckInData", storeData);
      this.$router.push(`/`);
    }
  }
};
</script>

<style>
</style>

